import { useState } from "react"
import { Link } from "react-router-dom"
//functions
import NumberToMoney from '../../../shared/functions/NumberToMoney'


/* form */
import Input from "../../../shared/components/form/input"
import FormLayout from "../../../shared/components/FormLayout/FormLayout"
import FormSection from "../../../shared/components/FormLayout/FormSection"
import Button from "../../../shared/components/Button/Button"


function FormAdditive({ handleSubmit, additiveData, btnText, btCancelLink, btCancelAction, title }) {

    const isEdit = !!additiveData
    const [additive, setAdditive] = useState(additiveData || {})

    function handleChange(e) {
        setAdditive({ ...additive, [e.target.name]: e.target.value })
    }

    function submit(e) {
        e.preventDefault()
        handleSubmit(additive)
    }
    /* ----------------- function  money 0.00 ------------------- */
    function handleChangeMoney(e) {
        let value = NumberToMoney(e.target.value)
        setAdditive({ ...additive, [e.target.name]: value })
    }

    return (
        <FormLayout
            title={title}
            onSubmit={submit}
            actions={
                <>
                    <Button variant="save" type="submit">{btnText || 'Salvar'}</Button>
                    {btCancelLink
                        ? <Link className="link-default" to={btCancelLink}><Button variant="cancel">Cancelar</Button></Link>
                        : btCancelAction && <Button variant="cancel" onClick={btCancelAction}>Cancelar</Button>
                    }
                </>
            }
        >
            <FormSection>
                <div className="fl-row">
                    <div className="fl-col-wide form-group">
                        <Input
                            text="Nome do aditivo"
                            type="text"
                            name="name"
                            placeholder="Nome"
                            handleOnChange={handleChange}
                            value={additive.name || ''}
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input
                            text="Preço"
                            type="number"
                            name="price"
                            placeholder="Preço"
                            handleOnChange={handleChange}
                            handleOnBlur={handleChangeMoney}
                            value={additive.price || ''}
                        />
                    </div>
                    <div className="fl-col-mid form-group">
                        <Input
                            text={`Custo${isEdit ? ' (opcional)' : ''}`}
                            type="number"
                            name="cost"
                            placeholder="Custo"
                            handleOnChange={handleChange}
                            handleOnBlur={handleChangeMoney}
                            value={additive.cost || ''}
                        />
                    </div>
                </div>
            </FormSection>
        </FormLayout>
    )
}

export default FormAdditive
